import { useState, useEffect, useCallback } from 'react';
import { api } from '../lib/api';

export function useStore() {
  const [business, setBusiness]     = useState(null);
  const [parties, setParties]       = useState([]);
  const [summary, setSummary]       = useState(null);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);

  const load = useCallback(async () => {
    try {
      const [b, p, s] = await Promise.all([api.getBusiness(), api.getParties(), api.getSummary()]);
      setBusiness(b); setParties(p); setSummary(s);
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addParty       = async (d)    => { await api.addParty(d);         await load(); };
  const updateParty    = async (id,d) => { await api.updateParty(id,d);   await load(); };
  const deleteParty    = async (id)   => { await api.deleteParty(id);     await load(); };
  const addTransaction = async (d)    => { await api.addTransaction(d);   await load(); };
  const delTransaction = async (id)   => { await api.deleteTransaction(id); await load(); };
  const updateBusiness = async (d)    => { const b = await api.updateBusiness(d); setBusiness(b); return b; };

  return {
    business, parties, summary, loading, error, reload: load,
    addParty, updateParty, deleteParty, addTransaction, delTransaction, updateBusiness,
  };
}
